<template>
  <v-container fill-height>
    <v-layout row wrap align-center justify-center>
      <v-flex xs10 text-center>
        <span v-if="!hasSent && !error" class="loading-circle"></span>

        <v-icon large v-if="hasSent" class="mb-5">mdi-thumb-up</v-icon>

        <h1 class="body-1" v-if="hasSent">Du kannst die App jetzt beenden.</h1>
        <h1 class="body-1" v-else-if="error">Es ist ein Fehler aufgetreten.</h1>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    hasSent: false,
    error: false
  }),
  methods: {
    send() {
      let data = {
        driverID: this.$store.state.driver.id,
        driverName: this.$store.state.driver.name,
        routeID: this.$store.state.route.id,
        routeCategory: this.$store.state.route.category
      };
      data = JSON.stringify(data);

      this.$socket.emit("driver awake", data, confirmation => {
        if (confirmation) {
          this.hasSent = true;
        }
      });
    }
  },
  mounted() {
    if (this.$store.state.route.id) {
      this.send();
    }
  }
};
</script>
